import { render, staticRenderFns } from "./Leg.vue?vue&type=template&id=4ca9f168&"
import script from "./Leg.vue?vue&type=script&lang=js&"
export * from "./Leg.vue?vue&type=script&lang=js&"
import style0 from "./Leg.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports